












































































































































import { Component, Watch } from 'vue-property-decorator'
import Alert from '@/components/Shared/Alert.vue';
import GiganautVue from '@/components/Shared/GiganautVue'
import { MigrationsModule } from '@/store/modules/migrations';
import { MigrationListItem, MigrationDetail } from '@/models/Migrations/MigrationModels';

@Component({
  name: 'MigrationsList',
  components: { Alert }
})
export default class extends GiganautVue {

  private sqlDialog = false;
  private sqlDirection: 'up' | 'down' = 'up';
  private rollbackDialog = false;
  private rollbackTarget: MigrationListItem | null = null;
  private rollbackText = '';
  private rollingBack = false;

  private headers = [
    { text: 'Version', value: 'version', width: '120px' },
    { text: 'Name', value: 'name' },
    { text: 'Status', value: 'status', width: '120px' },
    { text: 'Actions', value: 'actions', sortable: false, width: '130px' },
  ];

  get loading() {
    return MigrationsModule.loading;
  }

  get loadingDialog() {
    return MigrationsModule.loadingDialog;
  }

  get migrationStatus() {
    return MigrationsModule.migrationStatus;
  }

  get selectedDetail(): MigrationDetail | null {
    return MigrationsModule.currentMigrationDetail;
  }

  get migrationsReversed(): MigrationListItem[] {
    return [...this.migrationStatus.migrations].reverse();
  }

  get isProduction(): boolean {
    return this.migrationStatus.environment === 'prod';
  }

  get rollbackDisabled(): boolean {
    return this.rollbackText !== 'ROLLBACK';
  }

  created() {
    MigrationsModule.getMigrations();
  }

  @Watch('rollbackDialog')
  onRollbackDialogChanged(val: boolean) {
    if (val) {
      this.rollbackText = '';
    }
  }

  padVersion(version: number): string {
    return String(version).padStart(6, '0');
  }

  getStatusColor(item: MigrationListItem): string {
    if (item.isDirty) return 'error';
    if (item.isCurrent) return 'primary';
    if (item.isApplied) return 'success';
    return 'grey lighten-1';
  }

  getStatusLabel(item: MigrationListItem): string {
    if (item.isDirty) return 'Dirty';
    if (item.isCurrent) return 'Current';
    if (item.isApplied) return 'Applied';
    return 'Pending';
  }

  viewSql(item: MigrationListItem, direction: 'up' | 'down') {
    this.sqlDirection = direction;
    MigrationsModule.getMigrationDetail(item.version);
    this.sqlDialog = true;
  }

  confirmRollback(item: MigrationListItem) {
    this.rollbackTarget = item;
    this.rollbackDialog = true;
  }

  async executeRollback() {
    this.rollingBack = true;
    await MigrationsModule.rollbackMigration();
    this.rollingBack = false;
    this.rollbackDialog = false;
    this.rollbackTarget = null;
  }
}
